import React, {
  ReactNode,
  RefObject,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { SimpleCarouselItem } from "./SimpleCarouselItem";
import { ItemType, CarouselProps } from "../SimpleCarousel/types";
import clsx from "clsx";

const SimpleCarousel: React.FC<CarouselProps> = (props: CarouselProps) => {
  const [itemActive, setItemActive] = useState<number>(props.currentItem ?? 0);
  const wrapperRef = useRef<any>();
  const itemsRefs = useMemo(() => {
    return {} as { [key: string]: RefObject<HTMLDivElement> | null };
  }, []);

  useEffect(() => {
    setItemActive(props.currentItem ?? 0);
  }, [props.currentItem]);

  const [slides, bullets] = useMemo(() => {
    return (
      props.list?.reduce(
        (acc, item: ItemType, i: number) => {
          const slide = (
            <SimpleCarouselItem
              key={`item-${i}`}
              id={`item-${i}`}
              itemCustomClass={clsx(
                "top-[50%] absolute transition-opacity -translate-y-[50%] duration-500 ease-out",
                {
                  "opacity-0": itemActive !== i,
                  "opacity-100": itemActive === i,
                }
              )}
              refer={(inst: any) => {
                itemsRefs[`ref-item-${i}`] = inst;
              }}
              active={itemActive === i}
              onVisible={() => {
                props.onMove?.(itemActive);
              }}
              item={item}
            >
              <span className="mx-auto w-7/12 text-center">{item.content}</span>
            </SimpleCarouselItem>
          );
          const bullet = (
            <button className="btn btn-xs" onClick={() => false}>
              {i}
            </button>
          );
          return [acc[0].concat(slide), acc[1].concat(bullet)];
        },
        [[], []] as Array<ReactNode[]>
      ) ?? [[], []]
    );
  }, [props, itemsRefs, itemActive]);

  return (
    <div className="relative">
      <div ref={wrapperRef} className="pt-[200px] rounded-box w-full carousel">
        {slides}
      </div>
      {props.showBullets && (
        <div className="flex justify-center gap-2 py-2 w-full">{bullets}</div>
      )}
    </div>
  );
};

export default SimpleCarousel;
